<template>
    <div class="user-dis-info_page">
        <div>
            <div class="m-b-16 flex-ac flex-sb" v-if="lastMonthRedAndBlack.redSaleMap">
                <span class="mod-title f7"
                    >员工业绩红黑榜<span class="fs14">（{{ globalYearMonth }}_不含税_单位万）</span></span
                >
                <div>
                    <el-button-group>
                        <el-button @click="fetchTopData('month')" :type="redAndBlackDataType === 'month' ? 'primary' : ''" size="mini" >本月</el-button>
                        <el-button @click="fetchTopData('season')" :type="redAndBlackDataType === 'season' ? 'primary' : ''" size="mini" >本季</el-button>
                        <el-button @click="fetchTopData('year')" :type="redAndBlackDataType === 'year' ? 'primary' : ''" size="mini" >本年</el-button>
                    </el-button-group>
                </div>
            </div>
            <div class="mod-main user-dis-list" v-loading="lastMonthRedAndBlackLoading" v-if="lastMonthRedAndBlack.redSaleMap">
                <div class="fs22 m-b-18">{{redAndBlackDataType === 'month' ? '本月':redAndBlackDataType === 'season'?'本季':'本年'}}业绩红黑榜</div>
                <div class="flex-sb">
                    <div class="user-block red">
                        <img class="bg" src="../../../../static/imgs/red_bg.png" alt="">
                        <div class="user-name f6 fs30">{{ lastMonthRedAndBlack.redSaleMap ? lastMonthRedAndBlack.redSaleMap.userName :'-'}}</div>
                        <div class="title">
                            <div>
                                <span class="fs32 f6">{{ lastMonthRedAndBlack.redSaleMap ? lastMonthRedAndBlack.redSaleMap.xs_wcl :'-'}}</span><span class="fs16">%</span>
                            </div>
                            <div class="fs16">销售完成率</div>
                        </div>
                    </div>
                    <div class="user-block black">
                        <img class="bg" src="../../../../static/imgs/black_bg.png" alt="">
                        <div class="user-name f6 fs30">{{ lastMonthRedAndBlack.balckSaleMap ? lastMonthRedAndBlack.balckSaleMap.userName : '-' }}</div>
                        <div class="title">
                            <div>
                                <span class="fs32 f6">{{ lastMonthRedAndBlack.balckSaleMap ? lastMonthRedAndBlack.balckSaleMap.xs_wcl : '-' }}</span><span class="fs16">%</span>
                            </div>
                            <div class="fs16">销售完成率</div>
                        </div>
                    </div>
                    <div class="user-block red">
                        <img class="bg" src="../../../../static/imgs/red_bg.png" alt="">
                        <div class="user-name f6 fs30">{{ lastMonthRedAndBlack.redMlMap ? lastMonthRedAndBlack.redMlMap.userName : '-' }}</div>
                        <div class="title">
                            <div>
                                <span class="fs32 f6">{{ lastMonthRedAndBlack.redMlMap ? lastMonthRedAndBlack.redMlMap.ml_wcl : '-' }}</span><span class="fs16">%</span>
                            </div>
                            <div class="fs16">毛利完成率</div>
                        </div>
                    </div>
                    <div class="user-block black">
                        <img class="bg" src="../../../../static/imgs/black_bg.png" alt="">
                        <div class="user-name f6 fs30">{{ lastMonthRedAndBlack.balckMlMap ? lastMonthRedAndBlack.balckMlMap.userName : '-' }}</div>
                        <div class="title">
                            <div>
                                <span class="fs32 f6">{{ lastMonthRedAndBlack.balckMlMap ? lastMonthRedAndBlack.balckMlMap.ml_wcl : '-' }}</span><span class="fs16">%</span>
                            </div>
                            <div class="fs16">毛利完成率</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m-b-16 flex-ac flex-sb">
                <span class="mod-title f7"
                    >员工销售明细<span class="fs14">（{{ globalYearMonth }}_不含税_单位万）</span></span
                >
                <div>
                    <el-button-group>
                        <el-button size="mini" @click="fetchUserDisForType('week')" :type="disInfoType === 'week' ? 'primary' : ''">周</el-button>
                        <el-button size="mini" @click="fetchUserDisForType('month')" :type="disInfoType === 'month' ? 'primary' : ''">本月</el-button>
                        <el-button size="mini" @click="fetchUserDisForType('season')" :type="disInfoType === 'season' ? 'primary' : ''">本季</el-button>
                        <el-button size="mini" @click="fetchUserDisForType('year')" :type="disInfoType === 'year' ? 'primary' : ''">本年</el-button>
                        <el-button size="mini" @click="fetchUserDisForType('sum')" :type="disInfoType === 'sum' ? 'primary' : ''">累计</el-button>
                    </el-button-group>
                </div>
            </div>
            <!-- 周销售 -->
            <div class="flex-sb flex-wrap m-b-40" v-if="disInfoType === 'week'" v-loading="weekDisLoading">
                <div class="user-item m-b-34" :class="[{'blue': cssIsBlue.indexOf(index+1)>-1},{'orange': cssIsBlue.indexOf(index+1)===-1}]" v-for="(user,index) in weekDisList.userList" :key="user.user">
                    <div class="head flex-ac">
                        <div class="user-m flex-cc f7">{{ user.user[user.user.length - 1] }}</div>
                        <div class="user">{{ user.user }}</div>
                        <div class="link-more" @click="showUserInfo(user)">更多</div>
                    </div>
                    <div class="week-list">
                        <div class="week-item flex-ac fs16 m-b-16" :class="{'cur': idx+1 === weekDisList.weekList.length}" v-for="(item,idx) in weekDisList.weekList" :key="item.weekEnd">
                            <el-tooltip effect="dark" :content="`${item.weekStart} ~ ${item.weekEnd}`" placement="bottom">
                                <div class="week-num">第{{ idx+1 }}周 <i class="el-icon-warning-outline gray7f"></i></div>
                            </el-tooltip>
                            <div class="week-sale">销售：{{ user[`saleOutTaxMoney_${idx+1}`] || '/' }}</div>
                            <div>毛利：{{ user[`mlMoney_${idx+1}`] || '/' }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 月，季，年，累计，销售 -->
            <div class="m-b-40" v-loading="disInfoLoading">
                <div class="flex-sb flex-wrap">
                    <div class="user-item m-b-34" 
                    :class="[{'blue': cssIsBlue.indexOf(index+1)>-1},{'orange': cssIsBlue.indexOf(index+1)===-1}]" 
                    v-for="(user,index) in userDisList" :key="user.user">
                        <div class="head flex-ac">
                            <div class="user-m flex-cc f7">{{ user.user[user.user.length - 1] }}</div>
                            <div class="user">{{ user.user }}</div>
                            <div class="link-more" @click="showUserInfo(user)">更多</div>
                        </div>
                        <div class="month-wrapper fs16">
                            <div class="title flex-ac m-b-20">销售数据</div>
                            <div class="flex-ac m-b-16">
                                <div class="month-col flex-ac">
                                    <div class="label flex-ac">销售目标</div>
                                    <div class="f7">{{ user.saleTarget | moneyFormat }}</div>
                                </div>
                                <div class="month-col flex-ac">
                                    <div class="label flex-ac">实际完成</div>
                                    <div class="f7">{{ user.saleOutTaxMoney | moneyFormat }}</div>
                                </div>
                            </div>
                            <div class="flex-ac m-b-28">
                                <div class="month-col flex-ac">
                                    <div class="label flex-ac">差距</div>
                                    <div class="f7"  :class="{'green': user.sale_cj < 0,'hlg':user.sale_cj>0}">{{ user.sale_cj | moneyFormat }}</div>
                                </div>
                                <div class="month-col flex-ac">
                                    <div class="label flex-ac">完成率</div>
                                    <div class="f7"  :class="{'green': user.khxswcl < 0,'hlg':user.khxswcl>0}">{{ user.khxswcl }}%</div>
                                </div>
                            </div>
                            <div class="line m-b-28"></div>
                            <div class="title flex-ac m-b-20">毛利数据</div>
                            <div class="flex-ac m-b-16">
                                <div class="month-col flex-ac">
                                    <div class="label flex-ac">毛利目标</div>
                                    <div class="f7">{{ user.profitTarget | moneyFormat }}</div>
                                </div>
                                <div class="month-col flex-ac">
                                    <div class="label flex-ac">实际完成</div>
                                    <div class="f7">{{ user.mlMoney | moneyFormat }}</div>
                                </div>
                            </div>
                            <div class="flex-ac m-b-16">
                                <div class="month-col flex-ac">
                                    <div class="label flex-ac">差距</div>
                                    <div class="f7"  :class="{'green': user.ml_cj < 0,'hlg':user.ml_cj>0}">{{ user.ml_cj | moneyFormat }}</div>
                                </div>
                                <div class="month-col flex-ac">
                                    <div class="label flex-ac">完成率</div>
                                    <div class="f7"  :class="{'green': user.khmlwcl < 0,'hlg':user.khmlwcl>0}">{{ user.khmlwcl }}%</div>
                                </div>
                            </div>
                            <!-- <div class="flex-ac m-b-28">
                                <div class="month-col flex-ac">
                                    <div class="label flex-ac">正毛利</div>
                                    <div class="f7">{{ user.z_mlMoney | moneyFormat }}</div>
                                </div>
                                <div class="month-col flex-ac">
                                    <div class="label flex-ac">负毛利</div>
                                    <div class="f7">{{ user.f_mlMoney | moneyFormat }}</div>
                                </div>
                            </div> -->
                            <div class="line m-b-28"></div>
                            <div class="title flex-ac m-b-20">财务收入</div>
                            <div class="flex-ac">
                                <div class="month-col flex-ac">
                                    <div class="label flex-ac">承兑贴现</div>
                                    <div class="f7">{{ user.cdtx_money | moneyFormat }}<span class="fs12">{{ user.cdtx_money_unit }}</span></div>
                                </div>
                                <div class="month-col flex-ac">
                                    <div class="label flex-ac">利息收入</div>
                                    <div class="f7">{{ user.lxsr_money | moneyFormat }}<span class="fs12">{{ user.lxsr_money_unit }}</span></div>
                                </div>
                            </div>
                            <div :class="['more-data-wrap',{'open':user.isOpen}]">
                                <div class="line m-b-28"></div>
                                <div class="title flex-ac m-b-20">经营数据</div>
                                <div class="flex-ac m-b-28">
                                    <div class="month-col flex-ac">
                                        <div class="label flex-ac">经营利润</div>
                                        <div class="f7">{{ user.jyProfit | moneyFormat }}<span class="fs12">{{ user.jyProfit_unit }}</span></div>
                                    </div>
                                    <div class="month-col flex-ac">
                                        <div class="label flex-ac">经营费用</div>
                                        <el-tooltip placement="top" >
                                            <div slot="content">
                                                <div :class="{'m-b-10': index<user.jYCostList.length-1}" v-for="(item,index) in user.jYCostList" :key="item.sort">{{ item.serviceTypeName }}：{{ item.serviceMoney | moneyFormat }}{{ item.serviceMoney_unit }}</div>
                                            </div>
                                            <div class="f7">{{ user.serviceMoneyTotal | moneyFormat }}<span class="fs12 m-r-4">{{ user.serviceMoneyTotal_unit  }}</span><i class="el-icon-warning-outline hlg-red"></i></div>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <div class="line m-b-28"></div>
                                <div class="title flex-ac m-b-20">纳税数据</div>
                                <div class="flex-ac m-b-16">
                                    <div class="month-col flex-ac">
                                        <div class="label flex-ac">纳税总额</div>
                                        <div class="f7">{{ user.total_tax | moneyFormat }} <span class="fs12">{{ user.total_tax_unit }}</span></div>
                                    </div>
                                </div>
                                <div class="flex-ac">
                                    <div class="month-col flex-ac">
                                        <div class="label flex-ac">印花税</div>
                                        <el-tooltip placement="top" >
                                            <div slot="content">
                                                <div class="m-b-10">采购印花税：{{ user.cg_yh_tax | moneyFormat }}{{ user.cg_yh_tax_unit }}</div>
                                                <div>销售印花税：{{ user.xs_yh_tax | moneyFormat }}{{ user.xs_yh_tax_unit }}</div>
                                            </div>
                                            <div class="f7">{{ user.total_yh_tax | moneyFormat }} <span class="fs12 m-r-4">{{ user.total_yh_tax_unit  }}</span><i class="el-icon-warning-outline hlg-red"></i></div>
                                        </el-tooltip>
                                    </div>
                                    <div class="month-col flex-ac">
                                        <div class="label flex-ac">附加税</div>
                                        <div class="f7">{{ user.fj_tax | moneyFormat }} <span class="fs12">{{ user.fj_tax_unit }}</span></div>
                                    </div>
                                </div>
                            </div>
                            <div class="btn-more txt-center fs18" @click.stop="showMore(user)">
                                <span v-if="user.isOpen" class="el-icon-arrow-up arr"></span>
                                <span v-else class="el-icon-arrow-down arr"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <el-dialog :visible.sync="dialogUserDisTableVisible" width="74%" bottom="2vh">
            <div>
                <div class="m-b-16 flex-ac flex-sb">
                    <span class="mod-title f7">{{ curUserName }}的个人业绩完成情况<span class="fs14">（不含税_单位万）</span></span>
                    <el-button-group>
                        <el-button round @click="checkHeadOrFoot = 'head'" :type="checkHeadOrFoot === 'head' ? 'primary' : ''" size="mini" >上半年</el-button>
                        <el-button round @click="checkHeadOrFoot = 'foot'" :type="checkHeadOrFoot === 'foot' ? 'primary' : ''" size="mini" >下半年</el-button>
                    </el-button-group>
                </div>
                <div class="mod-main year-dis-info" v-show="checkHeadOrFoot === 'head'">
                    <div class="title fs16 f7 m-b-16">{{ getYear }}上半年业绩完成情况</div>
                    <el-table
                        :data="firstHalfYear"
                        style="width: 100%;font-size: 14px"
                        :cell-class-name="firstHlgColClassName"
                        :header-cell-style="{ color: '#3372E0', background: '#EDF1F7' }"
                    >
                        <el-table-column prop="label" label="">
                            <span class="f7" slot-scope="scope">{{ scope.row.label }}</span>
                        </el-table-column>
                        <el-table-column prop="d1" label="一月">
                            <span slot-scope="scope">{{ toFilter(scope.row.d1) }}</span>
                        </el-table-column>
                        <el-table-column prop="d2" label="二月">
                            <span slot-scope="scope">{{ toFilter(scope.row.d2) }}</span>
                        </el-table-column>
                        <el-table-column prop="d3" label="三月">
                            <span slot-scope="scope">{{ toFilter(scope.row.d3) }}</span>
                        </el-table-column>
                        <el-table-column prop="d4" label="四月">
                            <span slot-scope="scope">{{ toFilter(scope.row.d4) }}</span>
                        </el-table-column>
                        <el-table-column prop="d5" label="五月">
                            <span slot-scope="scope">{{ toFilter(scope.row.d5) }}</span>
                        </el-table-column>
                        <el-table-column prop="d6" label="六月">
                            <span slot-scope="scope">{{ toFilter(scope.row.d6) }}</span>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="mod-main year-dis-info" v-show="checkHeadOrFoot === 'foot'">
                    <div class="title fs16 f7 m-b-16">{{ getYear }}下半年业绩完成情况</div>
                    <el-table
                        :data="lastHalfYear"
                        style="width: 100%;font-size: 14px"
                        :cell-class-name="lastHlgColClassName"
                        :header-cell-style="{ color: '#3372E0', background: '#EDF1F7' }"
                    >
                        <el-table-column prop="label" label="">
                            <span class="f7" slot-scope="scope">{{ scope.row.label }}</span>
                        </el-table-column>
                        <el-table-column prop="d7" label="七月">
                            <span slot-scope="scope">{{ toFilter(scope.row.d7) }}</span>
                        </el-table-column>
                        <el-table-column prop="d8" label="八月">
                            <span slot-scope="scope">{{ toFilter(scope.row.d8) }}</span>
                        </el-table-column>
                        <el-table-column prop="d9" label="九月">
                            <span slot-scope="scope">{{ toFilter(scope.row.d9) }}</span>
                        </el-table-column>
                        <el-table-column prop="d10" label="十月">
                            <span slot-scope="scope">{{ toFilter(scope.row.d10) }}</span>
                        </el-table-column>
                        <el-table-column prop="d11" label="十一月">
                            <span slot-scope="scope">{{ toFilter(scope.row.d11) }}</span>
                        </el-table-column>
                        <el-table-column prop="d12" label="十二月">
                            <span slot-scope="scope">{{ toFilter(scope.row.d12) }}</span>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-dialog>

        <Siri
            :show-user-picker="false"
            :show-date-picker="true"
            @dateChange="globalDateChange"
            :date="globalYearMonth"
            :max-date="maxDate"
            scroll-target="scrollDom"
        />
    </div>
</template>

<script>
import utils from '../../../utils/utils';
import Siri from '../../common/dataPanel/Siri';
import ProgressForList from '../../common/dataPanel/ProgressForList.vue';

export default {
    name: 'data_panel_for_user',
    components: { Siri, ProgressForList },
    data() {
        var curYearMonth = utils.getCurDate('Array')[0] + '-' + utils.getCurDate('Array')[1];
        var curYear = utils.getCurDate('Array')[0];
        return {
            globalYearMonth: curYearMonth,
            maxDate: `${curYear}-12`,
            
            curUser: '',
            curUserName: '',

            firstHalfYear: [],
            lastHalfYear: [],
            color: ['#5D88F5', '#F27255', '#52CCA5', '#7D66F2', '#EBCC5E', '#F09254'],

            redAndBlackDataType: 'month', //  month 月  season 季  year 年

            lastMonthRedAndBlackLoading: true,
            lastMonthRedAndBlack: {
                balckMlMap: {},
                balckSaleMap: {},
                redMlMap: {},
                redSaleMap: {},
                month: ''
            },

            weekDisLoading: true,
            weekDisTableKey: true,
            weekDisList: {
                userList: [],
                weekList: []
            },

            disInfoLoading: true,
            userDisList: [],
            
            cssIsBlue: [ 1,2,5,6,9,10,13,14,17,18,21,22,25,26,29,30 ],
            disInfoType: 'month', //  week 周 month 月  season 季  year 年 sum 累计
            dialogUserDisTableVisible: false,
            checkHeadOrFoot: 'head'
        };
    },
    computed: {
        getYear: function() {
            return this.globalYearMonth.split('-')[0];
        },
        getMonth: function() {
            return this.globalYearMonth.split('-')[1];
        }
    },
    mounted() {
        this.fetchLastMonthRedAndBlack();
        
        this.fetchWeekDis();
        this.fetchDisDataForType();
    },
    methods: {
        showMore(user){
            user.isOpen = !user.isOpen
        },
        showUserInfo(user){
            this.curUser = user.userId;
            this.curUserName = user.user;
            this.fetchUserYearDisInfo();
            this.dialogUserDisTableVisible = true;
        },
        fetchUserDisForType(type){
            this.disInfoType = type;//  week 周 month 月  season 季  year 年 sum累计
            if(this.disInfoType !== 'week'){
                this.fetchDisDataForType()
            }
        },
        copyString(str){
            this.$copyText(str).then(()=>{
                this.$message.success('订单号已复制到剪切板')
            })
        },
        fetchTopData(redAndBlackDataType = 'month'){
            this.redAndBlackDataType = redAndBlackDataType;
            this.fetchLastMonthRedAndBlack();
        },
        // 红黑榜首
        fetchLastMonthRedAndBlack(){
            this.lastMonthRedAndBlackLoading = true;
            this.$http
                .post(this.$api.getLastMonthRedAndBlack.url, { 
                    dateType: this.redAndBlackDataType,
                    yearMonth: this.globalYearMonth
                })
                .then(res => {
                    this.lastMonthRedAndBlack = res.data || {};
                    this.lastMonthRedAndBlackLoading = false;
                })
                .catch(err => {});
        },
        fetchWeekDis() {
            this.weekDisLoading = true;
            this.$http
                .post(this.$api.getWeekLySaleData.url, {
                    yearMonth: this.globalYearMonth
                })
                .then(res => {
                    this.weekDisList = res.data || {
                        userList: [],
                        weekList: []
                    };
                    this.weekDisLoading = false;
                    // 重绘表头
                    this.weekDisTableKey = !this.weekDisTableKey;
                })
                .catch(err => {});
        },
       
        // 员工累计销售
        fetchDisDataForType(){
            this.disInfoLoading = true;
            this.$http
                .post(this.$api.getUserListSumSaleData.url, {
                    yearMonth: this.globalYearMonth,
                    dateType: this.disInfoType
                })
                .then(res => {
                    var userDisList = res.data.userList || [];
                    userDisList.map((user, index) => {
                        user.isOpen = false;
                    });
                    this.userDisList = userDisList;
                    this.disInfoLoading = false;
                })
                .catch(err => {});
        },
        toFilter(val) {
            if (!val || Object.prototype.toString.call(val) == '[object String]') {
                return val;
            } else {
                return this.$options.filters['moneyFormat'](val);
            }
        },
        fetchUserYearDisInfo() {
            this.$http
                .post(this.$api.getUserYearSaleList.url, {
                    yearMonth: this.globalYearMonth,
                    userId: this.curUser
                })
                .then(res => {
                    if (res.code !== 1) {
                        var firstHalfYear = [
                                { label: '销售目标' },
                                { label: '实际完成' },
                                { label: '差距' },
                                { label: '完成率' },
                                { label: '毛利目标' },
                                { label: '实际完成' },
                                { label: '差距' },
                                { label: '完成率' }
                            ],
                            lastHalfYear = [
                                { label: '销售目标' },
                                { label: '实际完成' },
                                { label: '差距' },
                                { label: '完成率' },
                                { label: '毛利目标' },
                                { label: '实际完成' },
                                { label: '差距' },
                                { label: '完成率' }
                            ];
                        res.data.map(monthData => {
                            if (monthData.month < 7) {
                                firstHalfYear.map((row, index) => {
                                    if (index === 0) {
                                        row['d' + monthData.month] = monthData.saleTarget || '-';
                                    } else if (index === 1) {
                                        row['d' + monthData.month] = monthData.saleOutTaxMoney || '-';
                                    } else if(index === 2){
                                        row['d' + monthData.month] = monthData.sale_cj || '-';
                                    } else if (index === 3) {
                                        row['d' + monthData.month] = monthData.khxswcl + '%';
                                    } else if (index === 4) {
                                        row['d' + monthData.month] = monthData.profitTarget || '-';
                                    } else if(index === 5){
                                        row['d' + monthData.month] = monthData.mlMoney || '-';
                                    } else if (index === 6) {
                                        row['d' + monthData.month] = monthData.ml_cj || '-';
                                    } else if (index === 7) {
                                        row['d' + monthData.month] = monthData.khmlwcl + '%';
                                    }
                                });
                            } else {
                                lastHalfYear.map((row, index) => {
                                    if (index === 0) {
                                        row['d' + monthData.month] = monthData.saleTarget || '-';
                                    } else if (index === 1) {
                                        row['d' + monthData.month] = monthData.saleOutTaxMoney || '-';
                                    } else if(index === 2){
                                        row['d' + monthData.month] = monthData.sale_cj || '-';
                                    } else if (index === 3) {
                                        row['d' + monthData.month] = monthData.khxswcl + '%';
                                    } else if (index === 4) {
                                        row['d' + monthData.month] = monthData.profitTarget || '-';
                                    } else if(index === 5){
                                        row['d' + monthData.month] = monthData.mlMoney || '-';
                                    } else if (index === 6) {
                                        row['d' + monthData.month] = monthData.ml_cj || '-';
                                    } else if (index === 7) {
                                        row['d' + monthData.month] = monthData.khmlwcl + '%';
                                    }
                                });
                            }
                        });
                        this.firstHalfYear = firstHalfYear;
                        this.lastHalfYear = lastHalfYear;
                    }
                });
        },
        
        globalDateChange(date) {
            this.globalYearMonth = date;
            this.fetchDisDataForType();
            this.fetchLastMonthRedAndBlack();
            this.fetchWeekDis();
            if(this.curUser){ this.fetchUserYearDisInfo(); }
        },
        
        firstHlgColClassName({row, column, rowIndex, columnIndex}){
            // console.log(row,column, rowIndex, columnIndex)
            if (rowIndex === 3 || rowIndex === 7) {
                var colValue = row['d'+columnIndex]
                if(!colValue){
                    return ''
                }else if(colValue.indexOf('%')>-1){
                    colValue = colValue.replace('%','')
                    if(colValue >= 100){
                        return 'hlg'
                    }else if(colValue < 100){
                        return 'green'
                    }
                }
            }
            if(rowIndex === 2 || rowIndex === 6){
                // console.log(row['d'+columnIndex])
                if(!row['d'+columnIndex]){
                    return ''
                }else if(row['d'+columnIndex] > 0){
                    return 'hlg'
                }else if(row['d'+columnIndex] < 0){
                    return 'green'
                } 
            }
        },
        lastHlgColClassName({row, column, rowIndex, columnIndex}){
            // console.log(row,column, rowIndex, columnIndex)
            if (rowIndex === 3 || rowIndex === 7) {
                var colValue = row['d'+(columnIndex+6)]
                if(!colValue){
                    return ''
                }else if(colValue.indexOf('%')>-1){
                    colValue = colValue.replace('%','')
                    if(colValue >= 100){
                        return 'hlg'
                    }else if(colValue < 100){
                        return 'green'
                    }
                }
            }
            if(rowIndex === 2 || rowIndex === 6){
                if(!row['d'+(columnIndex+6)]){
                    return ''
                }else if(row['d'+(columnIndex+6)] > 0){
                    return 'hlg'
                }else if(row['d'+(columnIndex+6)] < 0){
                    return 'green'
                } 
            }
        },
    }
};
</script>

<style lang="scss">
.user-dis-info_page{
    padding: 0 10px 60px;
    // 合计行样式
    .el-table .el-table__footer-wrapper .cell {
        color: #213991;
        font-weight: bold;
    }
    .mod-title {
        position: relative;
        font-size: 20px;
        padding-left: 12px;
        &::after {
            content: ' ';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 22px;
            background-color: #1a1a1a;
        }
    }

    .mod-main{
        &.user-dis-list{
            padding: 24px;
            margin-bottom: 28px;
        }
        &.gauge{
            padding: 32px 40px;
            margin-bottom: 32px;
        }
        &.year-dis-info{
            margin-bottom: 32px;
            padding: 32px 24px;
            .title{
                padding-left: 16px;
            }
        }
        border-radius: 16px;
        background-color: #fff;
        overflow: hidden;
    }
    
    .btn-more{
        padding: 24px 0;
        cursor: pointer;
        .arr{
            animation: bounce 1s infinite;
        }
    }
    .more-data-wrap{
        height: 0;
        overflow: hidden;
        transition: all 300ms;
        &.open{
            height: 259px;
            margin-top: 32px;
        }
    }
    .user-dis-list{
        .hlg{
            color: #F36F52;
        }
    }
    .dis-row{
        .title{
            &::before{
                content:'';
                display: block;
                width: 6px;
                height: 16px;
                border-radius: 3px;
                margin-right: 12px;
            }
        }
        .label{
            margin-right: 16px;
            &::before{
                content:'';
                display: block;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                margin-right: 6px;
            }
        }
        &.blue{
            .title{
                &::before{
                    background: #3372E0;
                }
            }
            .label{
                &::before{
                    background: #CFE0FF;
                }
            }
        }
        &.orange{
            .title{
                &::before{
                    background: #f36f52;
                }
            }
            .label{
                &::before{
                    background: #FFECCF;
                }
            }
        }
    }
    .user-item{
        width: 48%;
        border-radius: 16px;
        overflow: hidden;
        &.blue{
            .head{ background: linear-gradient(90deg, #345FE0 0%, #9EB6FF 100%); }
            .week-num,.user-m{ color: #3372E0; }
            .month-wrapper{
                .title{
                    &::before{
                        background: #3372E0;
                    }
                }
                .label{
                    &::before{
                        background: #CFE0FF;
                    }
                }
            }
        }
        &.orange{
            .head{ background: linear-gradient(90deg, #FF8400 0%, #FFD09E 100%); }
            .week-num,.user-m{ color: #f36f52; }
            .month-wrapper{
                .title{
                    &::before{
                        background: #f36f52;
                    }
                }
                .label{
                    &::before{
                        background: #FFECCF;
                    }
                }
            }
        }
        .head{
            height: 72px;
            padding: 0 24px 0;

        }
        .user{
            margin-right: auto;
            font-size: 24px;
            color: #fff;
        }
        .user-m{
            width: 48px;
            height: 48px;
            background: #FFFFFF;
            border-radius: 50%;
            font-size: 20px;
            margin-right:16px;
        }
        .link-more{
            color: #fff;
            font-size: 16px;
            padding-right: 20px;
            cursor: pointer;
            position: relative;
            &::after{
                content: '';
                position: absolute;
                right: 0;
                top: 7px;
                width: 8px;
                height: 8px;
                border-top: 1px solid #fff;
                border-right: 1px solid #fff;
                transform: rotateZ(45deg);
            }
        }
        .week-list{
            padding: 24px 24px 8px;
            background-color: #fff;
        }
        .week-item{
            height: 72px;
            background: #EDF1F7;
            border-radius: 16px;
            padding-left:24px;
            &.cur{
                background: #fff;
                box-shadow: 0px 2px 16px 0px rgba(0,0,0,0.05);
            }
        }
        .week-num{
            margin-right: 26px;
        }
        .week-sale{
            width: 160px;
        }
        .month-wrapper{
            padding: 32px 32px 0;
            background-color: #fff;
            border-radius: 0 0 16px 16px;
            .title{
                &::before{
                    content:'';
                    display: block;
                    width: 6px;
                    height: 16px;
                    border-radius: 3px;
                    margin-right: 12px;
                }
            }
            .label{
                width: 100px;
                &::before{
                    content:'';
                    display: block;
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    margin-right: 6px;
                }
            }
            .month-col{
                width: 50%;
            }
            .line{
                border-top: 1px dashed #e0e0e0;
            }
        }
        .green{ color: #0CA867; }
        .hlg { color: #f36f52; }
    }

    .el-table .warning-row {
        background: #EBEEF5;
    }
    .el-table .hlg {
        color: #213991;
    }
    .el-table .hlg-orange {
        color: #f36f52;
    }
    .el-table .green {
        color: #0CA867;
    }
    .el-table .gray-light {
        color: #999;
    }
    .el-scrollbar {
        > .el-scrollbar__bar {
            opacity: 1 !important;
        }
    }
    .m-b-16{
        margin-bottom: 16px;
    }
    .empty {
        text-align: center;
        color: #999;
    }
    .gray-bg{
        background-color: #F3F6FA;
    }
    .user-block{
        width: 22%;
        height: 304px;
        position: relative;
        border-radius: 16px;
        &.red{
            background: linear-gradient(0deg, #E9340A 0%, #F8B85B 100%);
            box-shadow: 0px 16px 40px 0px rgba(255,54,0,0.3);
            .bg{
                width: calc(100% - 80px);
                position: absolute;
                top: 20px;
                left: 50%;
                transform: translateX(-50%);
                z-index: 0;
            }
            .user-name{
                position: absolute;
                top: 132px;
                left: 50%;
                transform: translateX(-50%);
                z-index: 1;
            }
        }
        &.black{
            background: linear-gradient(0deg, #585452 0%, #C8C5C3 100%);
            .bg{
                width: calc(100% - 100px);
                position: absolute;
                top: 48px;
                left: 50%;
                transform: translateX(-50%);
                z-index: 0;
            }
            .user-name{
                position: absolute;
                top: 152px;
                left: 50%;
                transform: translateX(-50%);
                z-index: 1;
                color: #fff;
            }
        }
        .title{
            position: absolute;
            bottom: 40px;
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
            color: #fff;
            z-index: 1;
        }
    }
}
.empty-img{
    text-align: center;
    .icon{
        width: 294px;
        height: 160px;
    }
}
@keyframes bounce {
    0%, 100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-8px);
    }
}
</style>
